import { forwardRef } from 'react';
import classNames from 'classnames';

const NumberField = forwardRef(({ field, value, onChange, style, required, maxLength }, ref) => {
  const handleChange = (e) => {
    const val = e.target.value;
    // Allow empty string, digits, decimal point, and negative sign
    if (val === '' || /^-?\d*\.?\d*$/.test(val)) {
      onChange(field.name, val);
    }
  };

  return (
    <input
      ref={ref}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      className={classNames('pdf-text-field pdf-number-field', { 'field-required': required })}
      value={value || ''}
      onChange={handleChange}
      maxLength={maxLength}
      style={{
        position: 'absolute',
        ...style,
        border: style.border || '1px solid #ccc',
        fontSize: style.fontSize || '12px',
        fontFamily: style.fontFamily || "'Times New Roman', Times, serif",
        fontWeight: style.fontWeight || 'normal',
        fontStyle: style.fontStyle || 'normal',
        textDecoration: style.textDecoration || 'none',
        color: style.color || '#000000',
        textAlign: style.textAlign || 'left',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: '2px 4px',
        boxSizing: 'border-box'
      }}
    />
  );
});

NumberField.displayName = 'NumberField';

export default NumberField;
